"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Modal_1 = __importDefault(require("@web/common/Modal"));
const termsConditionsModalLinks = Array.from(document.querySelectorAll('.terms-conditions-modal-open'));
termsConditionsModalLinks.forEach((termsConditionsModal) => new Modal_1.default(termsConditionsModal));
